import React from "react";
import LatestFinancialResultClient from "./LatestFinancialResultClient";
import LatestFinancialHeader from "./LatestFinancialHeader";
import { getFlipitNews } from "../../services/TradingMallService";
import BFLApiFailure from "@repo/shared-ui/BFLApiFailure";
import StockListNotFound from "../ClpStockCards/StockListNotFound";

interface LatestFinancialResultProps {
  heading?: string;
  description?: string;
  viewAll?: string;
  redirectUrl?: string;
  componentPosition?: string;
  openInNewTab?: boolean | string;
}

const LatestFinancialResult: React.FC<LatestFinancialResultProps> = async ({
  heading,
  description,
  viewAll,
  redirectUrl,
  componentPosition,
  openInNewTab,
}) => {
  let initialStocks: any[] = [];
  let hasError = false;

  try {
    const response = await getFlipitNews(1, 10);
    const news = response?.data?.news ?? [];
    initialStocks = news.slice(0, 5);
  } catch (error) {
    console.error("Failed to load latest financial results:", error);
    hasError = true;
  }

  const resolvedHeading = heading ?? "Latest financial results";
  const resolvedDescription =
    description ??
    "Explore Latest financial results and start investing right away.";
  const resolvedViewAll = viewAll ?? "View all";
  const resolvedHref = redirectUrl ?? "/investments/latest-financials-result";

  // Error state (reference: OtherNews section)
  if (hasError && initialStocks.length === 0) {
    return (
      <div
        id="financial-results"
        className="scroll-mt-(--bfl-header-height-mobile) md:scroll-mt-(--bfl-header-height-desktop) py-3 md:py-4 px-4 flex flex-col gap-3"
      >
        <LatestFinancialHeader
          header={resolvedHeading}
          description={resolvedDescription}
        />
        <div className="flex min-h-[400px] items-center justify-center py-12">
          <BFLApiFailure
            imageSrc=""
            imageAlt="Error"
            error="Unable to fetch the information at this time"
            errorDescription="Please try again later"
            retryButtonText="Retry"
          />
        </div>
      </div>
    );
  }

  // Empty state (reference: OtherNews section)
  if (!hasError && initialStocks.length === 0) {
    return (
      <div
        id="financial-results"
        className="scroll-mt-(--bfl-header-height-mobile) md:scroll-mt-(--bfl-header-height-desktop) py-3 md:py-4 px-4 flex flex-col gap-3"
      >
        <LatestFinancialHeader
          header={resolvedHeading}
          description={resolvedDescription}
        />
          <StockListNotFound
            errorMessage="No financial results available at the moment."
            stockNotFoundImgUrl="https://cms-assets.bajajfinserv.in/is/image/bajajfinance/no-stocks"
          />
      </div>
    );
  }

  return (
    <div
      id="financial-results"
      className="scroll-mt-(--bfl-header-height-mobile) md:scroll-mt-(--bfl-header-height-desktop) py-3 md:py-4 px-4 flex flex-col gap-3"
    >
      <LatestFinancialHeader
        header={resolvedHeading}
        description={resolvedDescription}
      />
      <LatestFinancialResultClient
        label={resolvedViewAll}
        href={resolvedHref}
        stocks={initialStocks}
        sectionTitle={resolvedHeading}
        componentPosition={componentPosition}
        openInNewTab={openInNewTab}
      />
    </div>
  );
};

export default LatestFinancialResult;